import { render, staticRenderFns } from "./rationality_analysis.vue?vue&type=template&id=28774ab8&scoped=true"
import script from "./rationality_analysis.vue?vue&type=script&lang=js"
export * from "./rationality_analysis.vue?vue&type=script&lang=js"
import style0 from "./rationality_analysis.vue?vue&type=style&index=0&id=28774ab8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28774ab8",
  null
  
)

export default component.exports